<template>
  <div>
    <div class="home">
      <banner-image></banner-image>
      <!-- 最新活动 start -->
      <div class="home-Latestevents">
        <div class="home-Latestevents-title">
          <p class="home-Latestevents-p1">Latest activity</p>
          <p class="home-Latestevents-p2">最 新 活 动</p>
        </div>
        <div class="home-Latestevents-title2">
          <p class="home-Latestevents-p4">最 新 活 动</p>
          <p class="home-Latestevents-p3">Latest activity</p>
        </div>
        <div class="home-Latestevents-content">
          <div class="activity-number">
            <el-row>
              <el-col>
                <div class="home-Latestevents-number-item">
                  <div class="home-Latestevents-item-image">
                    <img :src="activityList[0].picture" />
                  </div>
                  <div class="home-Latestevents-item-text-b">
                    <div class="home-Latestevents-item-text">
                      <div class="home-Latestevents-item-text-title">
                        <p class="home-Latestevents-nubmer">
                          <span>{{activityList[0].title}}</span>
                        </p>
                      </div>
                      <div class="home-Latestevents-item-text-main">
                        <p class="home-Latestevents-text">
                          {{activityList[0].description}}
                        </p>
                      </div>
                      <div class="home-Latestevents-small-white-box"></div>
                      <div class="home-Latestevents-small-green-box"></div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="activity-number-two">
            <el-row>
              <el-col>
                <div class="home-Latestevents-number-item-2">
                  <div class="home-Latestevents-item-text-b-2">
                    <div class="home-Latestevents-item-text-2">
                      <div class="home-Latestevents-item-text-title-2">
                        <p class="home-Latestevents-nubmer-2">
                          <span>{{activityList[1].title}}</span>
                          <span>最新活动</span>
                        </p>
                      </div>
                      <div class="home-Latestevents-item-text-main-2">
                        <p class="home-Latestevents-text-2">
                          {{activityList[1].description}}
                        </p>
                      </div>
                      <div class="home-Latestevents-small-white-box-2"></div>
                      <div class="home-Latestevents-small-green-box-2"></div>
                    </div>
                  </div>
                  <div class="home-Latestevents-item-image-2">
                    <img :src="activityList[1].picture" />
                  </div>

                </div>
              </el-col>
            </el-row>
          </div>
          <div class="product-bntbox">
            <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
          </div>
        </div>
      </div>
      <!-- 最新活动 end -->
      <!-- 产品与服务 start -->
      <div class="home-Productservices">
        <div class="home-Productservices-banner">
          <div class="home-Productservices-title">
            <p class="home-Productservices-p2">产 品 及 服 务</p>
            <p class="home-Productservices-p1">Products and services</p>
          </div>
          <div class="home-Productservices-title2">
            <p class="home-Productservices-p4">产 品 及 服 务</p>
            <p class="home-Productservices-p3">Products and services</p>
          </div>
          <div class="home-Productservices-box1">
            <div class="home-Productservices-box1-ron">
              <div class="home-Productservices-box1-ron-con1">
                <div class="home-Productservices-box1-ron-con1-imtx">
                  <img class="home-Productservices-App-img" src="../assets/home-image/phone.png" />
                  <p class="home-Productservices-App">{{productsList[0].name}}</p>
                </div>
                <div class="home-Productservices-box1-ron-con1-text">
                  <p>{{productsList[0].description}}</p>
                </div>
              </div>
              <div class="home-Productservices-box1-ron-con2">
                <div class="home-Productservices-box1-ron-con1-imtx">
                  <img class="home-Productservices-wx-img" src="../assets/home-image/weixinchengyu.png" />
                  <p class="home-Productservices-wechat">{{productsList[1].name}}</p>
                </div>
                <div class="home-Productservices-box1-ron-con1-text">
                  <p>{{productsList[1].description}}</p>
                </div>
              </div>
              <div class="home-Productservices-box1-ron-con3">
                <div class="home-Productservices-box1-ron-con1-imtx">
                  <img class="home-Productservices-wifi-img" src="../assets/home-image/wifi.png" />
                  <p class="home-Productservices-wifi">{{productsList[2].name}}</p>
                </div>
                <div class="home-Productservices-box1-ron-con1-text">
                  <p>{{productsList[2].description}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="home-Productservices-box2">
            <div class="home-Productservices-box2-ron">
              <div class="home-Productservices-box1-ron-con1">
                <div class="home-Productservices-box1-ron-con1-imtx">
                  <img class="home-Productservices-saas-img" src="../assets/home-image/saasmodel.png" />
                  <p class="home-Productservices-saas">{{productsList[3].name}}</p>
                </div>
                <div class="home-Productservices-box1-ron-con1-text">
                  <p>{{productsList[3].description}}</p>
                </div>
              </div>
              <div class="home-Productservices-box1-ron-con2">
                <div class="home-Productservices-box1-ron-con1-imtx">
                  <img class="home-Productservices-wechat-img" src="../assets/home-image/wechat.png" />
                  <p class="home-Productservices-weat">{{productsList[4].name}}</p>
                </div>
                <div class="home-Productservices-box1-ron-con1-text">
                  <p>{{productsList[4].description}}</p>
                </div>
              </div>
              <div class="home-Productservices-box1-ron-con3">
                <div class="home-Productservices-box1-ron-con1-imtx">
                  <img class="home-Productservices-teach-img" src="../assets/home-image/teach.png" />
                  <p class="home-Productservices-teach">{{productsList[5].name}}</p>
                </div>
                <div class="home-Productservices-box1-ron-con1-text">
                  <p>{{productsList[5].description}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 48rem 一个一个格 -->
        <div class="home-Productservices-banner1">
          <div class="home-Productservices-title2">
            <p class="home-Productservices-p4">产 品 及 服 务</p>
            <p class="home-Productservices-p3">Products and services</p>
          </div>
          <div class="home-Productservices-box11-ron">
            <div class="home-Productservices-box11-ron-con1">
              <div class="home-Productservices-box11-ron-con1-imtx">
                <img class="home-Productservices-App1-img" src="../assets/home-image/phone.png" />
                <p class="home-Productservices-App1">{{productsList[0].name}}</p>
              </div>
              <div class="home-Productservices-box11-ron-con1-text">
                <p>{{productsList[0].description}}</p>
              </div>
            </div>
          </div>
          <div class="home-Productservices-box11-ron">
            <div class="home-Productservices-box11-ron-con2">
              <div class="home-Productservices-box11-ron-con1-imtx">
                <img class="home-Productservices-wx1-img" src="../assets/home-image/weixinchengyu.png" />
                <p class="home-Productservices-wechat1">{{productsList[1].name}}</p>
              </div>
              <div class="home-Productservices-box11-ron-con1-text">
                <p>{{productsList[1].description}}</p>
              </div>
            </div>
          </div>
          <div class="home-Productservices-box11-ron">
            <div class="home-Productservices-box11-ron-con3">
              <div class="home-Productservices-box11-ron-con1-imtx">
                <img class="home-Productservices-wifi1-img" src="../assets/home-image/wifi.png" />
                <p class="home-Productservices-wifi1">{{productsList[2].name}}</p>
              </div>
              <div class="home-Productservices-box11-ron-con1-text">
                <p>{{productsList[2].description}}</p>
              </div>
            </div>
          </div>
          <div class="home-Productservices-box11-ron">
            <div class="home-Productservices-box11-ron-con1">
              <div class="home-Productservices-box11-ron-con1-imtx">
                <img class="home-Productservices-saas1-img" src="../assets/home-image/saasmodel.png" />
                <p class="home-Productservices-saas1">{{productsList[3].name}}</p>
              </div>
              <div class="home-Productservices-box11-ron-con1-text">
                <p>{{productsList[3].description}}</p>
              </div>
            </div>
          </div>
          <div class="home-Productservices-box11-ron">
            <div class="home-Productservices-box11-ron-con2">
              <div class="home-Productservices-box11-ron-con1-imtx">
                <img class="home-Productservices-wechat1-img" src="../assets/home-image/wechat.png" />
                <p class="home-Productservices-weat1">{{productsList[4].name}}</p>
              </div>
              <div class="home-Productservices-box11-ron-con1-text">
                <p>{{productsList[4].description}}</p>
              </div>
            </div>
          </div>
          <div class="home-Productservices-box11-ron">
            <div class="home-Productservices-box11-ron-con3">
              <div class="home-Productservices-box11-ron-con1-imtx">
                <img class="home-Productservices-teach1-img" src="../assets/home-image/teach.png" />
                <p class="home-Productservices-teach1">{{productsList[5].name}}</p>
              </div>
              <div class="home-Productservices-box11-ron-con1-text">
                <p>{{productsList[5].description}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 48rem 一个一个格 -->


        <div class="product-bntboxtwo">
          <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
        </div>
      </div>
      <!-- 产品与服务 end -->
      <!-- 合作案例 start -->
      <div class="home-Cooperaprog">
        <div class="home-Cooperaprog-banner">
          <div class="home-Cooperaprog-title">
            <p class="home-Cooperaprog-p1">Cooperation cases</p>
            <p class="home-Cooperaprog-p2">合 作 案 例</p>
          </div>
          <div class="home-Cooperaprog-title2">
            <p class="home-Cooperaprog-p4">合 作 案 例</p>
            <p class="home-Cooperaprog-p3">Cooperation cases</p>
          </div>
          <div class="home-Cooperaprog-box1">
            <div class="home-Cooperaprog-box1-ron">
              <div class="home-Cooperaprog-box1-one">
                <div class="home-Cooperaprog-box1-one-imtx">
                  <img src="../assets/home-image/huilingdun.png" />
                  <p class="home-Cooperaprog-box1-huining">{{CooperationList[0].title}}</p>
                </div>
                <div class="home-Cooperaprog-box1-one-text">
                  <p>
                    {{CooperationList[0].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
              <div class="home-Cooperaprog-box1-two">
                <div class="home-Cooperaprog-box1-one-imtx">
                  <img src="../assets/home-image/donghua.png" />
                  <p class="home-Cooperaprog-box1-donghua">{{CooperationList[1].title}}</p>
                </div>
                <div class="home-Cooperaprog-box1-one-text">
                  <p>
                    {{CooperationList[1].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton2">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
              <div class="home-Cooperaprog-box1-three">
                <div class="home-Cooperaprog-box1-one-imtx">
                  <img src="../assets/home-image/jingcheng.png" />
                  <p class="home-Cooperaprog-box1-jingcheng">{{CooperationList[2].title}}</p>
                </div>
                <div class="home-Cooperaprog-box1-one-text">
                  <p>
                    {{CooperationList[2].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton2">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="home-Cooperaprog-box2">
            <div class="home-Cooperaprog-box2-ron">
              <div class="home-Cooperaprog-box2-one">
                <div class="home-Cooperaprog-box1-one-imtx">
                  <img src="../assets/home-image/huilingdun.png" />
                  <p class="home-Cooperaprog-box1-donghua">{{CooperationList[3].title}}</p>
                </div>
                <div class="home-Cooperaprog-box1-one-text">
                  <p>
                    {{CooperationList[3].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton2">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
              <div class="home-Cooperaprog-box2-two">
                <div class="home-Cooperaprog-box1-one-imtx">
                  <img src="../assets/home-image/huilingdun.png" />
                  <p class="home-Cooperaprog-box1-menghuang">{{CooperationList[4].title}}</p>
                </div>
                <div class="home-Cooperaprog-box1-one-text">
                  <p>
                    {{CooperationList[4].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton2">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
              <div class="home-Cooperaprog-box2-three">
                <div class="home-Cooperaprog-box1-one-imtx">
                  <img src="../assets/home-image/donghua.png" />
                  <p class="home-Cooperaprog-box1-antuo">{{CooperationList[5].title}}</p>
                </div>
                <div class="home-Cooperaprog-box1-one-text">
                  <p>
                    {{CooperationList[5].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton2">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 48rem 出现 -->
        <div class="home-Cooperaprog-banner1">
          <div class="home-Cooperaprog-title2">
            <p class="home-Cooperaprog-p4">合 作 案 例</p>
            <p class="home-Cooperaprog-p3">Cooperation cases</p>
          </div>
          <div class="home-Cooperaprog-box11">
            <div class="home-Cooperaprog-box11-ron">
              <div class="home-Cooperaprog-box11-one">
                <div class="home-Cooperaprog-box11-one-imtx">
                  <img src="../assets/home-image/huilingdun.png" />
                  <p class="home-Cooperaprog-box11-huining">{{CooperationList[0].title}}</p>
                </div>
                <div class="home-Cooperaprog-box11-one-text">
                  <p>
                    {{CooperationList[0].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
              <div class="home-Cooperaprog-box11-two">
                <div class="home-Cooperaprog-box11-one-imtx">
                  <img src="../assets/home-image/donghua.png" />
                  <p class="home-Cooperaprog-box11-donghua">{{CooperationList[1].title}}</p>
                </div>
                <div class="home-Cooperaprog-box11-one-text">
                  <p>
                    {{CooperationList[1].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton2">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="home-Cooperaprog-box11">
            <div class="home-Cooperaprog-box11-ron">
              <div class="home-Cooperaprog-box11-three">
                <div class="home-Cooperaprog-box11-one-imtx">
                  <img src="../assets/home-image/jingcheng.png" />
                  <p class="home-Cooperaprog-box11-jingcheng">{{CooperationList[2].title}}</p>
                </div>
                <div class="home-Cooperaprog-box11-one-text">
                  <p>
                    {{CooperationList[2].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton2">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
              <div class="home-Cooperaprog-box22-one">
                <div class="home-Cooperaprog-box11-one-imtx">
                  <img src="../assets/home-image/huilingdun.png" />
                  <p class="home-Cooperaprog-box11-donghua">{{CooperationList[3].title}}</p>
                </div>
                <div class="home-Cooperaprog-box11-one-text">
                  <p>
                    {{CooperationList[3].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton2">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="home-Cooperaprog-box11">
            <div class="home-Cooperaprog-box11-ron">
              <div class="home-Cooperaprog-box22-two">
                <div class="home-Cooperaprog-box11-one-imtx">
                  <img src="../assets/home-image/huilingdun.png" />
                  <p class="home-Cooperaprog-box11-menghuang">{{CooperationList[4].title}}</p>
                </div>
                <div class="home-Cooperaprog-box11-one-text">
                  <p>
                    {{CooperationList[4].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton2">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
              <div class="home-Cooperaprog-box22-three">
                <div class="home-Cooperaprog-box11-one-imtx">
                  <img src="../assets/home-image/donghua.png" />
                  <p class="home-Cooperaprog-box11-antuo">{{CooperationList[5].title}}</p>
                </div>
                <div class="home-Cooperaprog-box11-one-text">
                  <p>
                    {{CooperationList[5].description}}
                  </p>
                </div>
                <div class="home-Cooperaprog-box1-one-bigbotton">
                  <div class="home-Cooperaprog-box1-one-botton2">
                    <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 48rem 出现 -->
        <div class="product-bntboxtwo">
          <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
        </div>
      </div>
      <!-- 合作案例 end -->
      <!-- 关于我们 start -->
      <div class="home-Aboutus">
        <div class="home-Aboutus-banner">
          <div class="home-Aboutus-title">
            <p class="home-Aboutus-p1">ABOUT US</p>
            <p class="home-Aboutus-p2">关 于 我 们</p>
          </div>
          <div class="home-Aboutus-title2">
            <p class="home-Aboutus-p4">关 于 我 们</p>
            <p class="home-Aboutus-p3">ABOUT US</p>
          </div>
          <div class="home-Aboutus-con">
            <p>
              即刻优势通过人工智能、云计算、大数据、5G物联网等创新型技术革新传统教育管
              理方式，快速帮助赦育管理者实现高效的教育教学管理，教育科研和教育营销等解
              决方案，让教育行业迈向智能化转型，实现全方位的教育现代化。
            </p>
          </div>
          <div class="home-Aboutus-botton">
            <el-button round>了解更多<i class="el-icon-arrow-right"></i></el-button>
          </div>
        </div>
      </div>
      <!-- 关于我们 end -->
      <!-- 底部引入 -->
      <FooderContent></FooderContent>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  /* 底部内容 */
  import FooderContent from '../components/fooder.vue'
  /* bannar */
  import BannerImage from '../components/Bannar.vue'
  import {latestEvents,list,caseslist} from '../../api/index.js'
  import {url} from '../../config/config.js'
  export default {
    name: 'HomePage',
    components: {
      FooderContent,
      BannerImage
    },
    created(){
      //最新活动
      latestEvents()
      .then(res=>{
        res.data.data.map(activityList=>{
          activityList.picture = url + activityList.picture
        })
        this.activityList=res.data.data
        console.log(this.activityList)
      })
      .catch(err=>{
        alert('错误信息：'+err.msg)
      })
      //产品与服务
      list().then(res=>{
        res.data.data.map(productsList=>{
          productsList.picture = url + productsList.picture
        })
        this.productsList=res.data.data
        console.log(this.productsList)
      })
      .catch(err=>{
        alert('错误信息'+err.msg)
      })
      //合作案例
      caseslist().then(res=>{
        res.data.data.map(CooperationList=>{
          CooperationList.picture = url + CooperationList.picture
        })
        this.CooperationList=res.data.data
        console.log(this.CooperationList)
      })
      .catch(err=>{
        alert('错误信息'+err.msg)
      })
    },
    data() {
      return {
        bannerlist: [{
            id: '01',
            ulr: '../assets/home-image/neonbrand-1-aA2Fadydc-unsplash.jpg'
          },
          {
            id: '02',
            ulr: '../assets/home-image/neonbrand-1-aA2Fadydc-unsplash.jpg'
          }
        ],
        activityList:[],
        productsList:[],
        CooperationList:[],
      }
    }
  }
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    list-style: none;
    text-decoration: none;
  }

  /* 最新活动标题 */
.home-Latestevents-title {
	width: 5%;
	height: 9.5rem;
	position: relative;
	top: 160px;
	left: 35px;
	z-index: 999
}

.home-Latestevents-p1 {
	width: 20px;
	height: 115px;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	margin-left: 5px
}

.home-Latestevents-p1,
.home-Latestevents-p2 {
	-webkit-writing-mode: vertical-rl;
	-ms-writing-mode: tb-rl;
	writing-mode: vertical-rl;
	font-family: Source Han Sans SC;
	color: #333;
	opacity: 1;
	float: left
}

.home-Latestevents-p2 {
	width: 26px;
	height: 152px;
	font-size: 26px;
	font-weight: 400;
	line-height: 38px;
	margin-left: 15px
}

.home-Latestevents-title2 {
	width: 5%;
	height: 9.5rem;
	position: relative;
	top: 160px;
	left: 35px;
	z-index: 999;
	display: none
}

.home-Latestevents-p3 {
	width: 20px;
	height: 115px;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	margin-left: 5px
}

.home-Latestevents-p3,
.home-Latestevents-p4 {
	font-family: Source Han Sans SC;
	color: #333;
	opacity: 1;
	float: left
}

.home-Latestevents-p4 {
	width: 26px;
	height: 152px;
	font-size: 26px;
	font-weight: 400;
	line-height: 38px;
	margin-left: 15px
}

  /* one 最新活动 start */
  .home-Latestevents-number-item-2 {
  	width: 100rem;
  	height: 34rem;
  	margin: 3.125rem auto;
  	position: relative
  }

  .home-Latestevents-item-image-2 {
  	width: 60.4375rem;
  	height: 100%;
  	background-size: 100% 100%;
  	float: left;
  	overflow: hidden
  }

  .home-Latestevents-item-image-2 img {
  	width: 100%;
  	height: auto;
  	-webkit-transition: all .5s linear;
  	transition: all .5s linear
  }

  .home-Latestevents-item-image-2 img:hover {
  	cursor: default;
  	-webkit-transform: scale(1.2);
  	transform: scale(1.2)
  }

  .home-Latestevents-item-text-b-2 {
  	width: 39.5rem;
  	height: 34rem;
  	float: left;
  	background-color: #27cbbd
  }

  .home-Latestevents-item-text-2 {
  	width: 30rem;
  	height: 30rem;
  	overflow: auto;
  	float: left;
  	margin-left: 1.25rem;
  	overflow: hidden
  }

  .home-Latestevents-item-text-2 :hover {
  	-webkit-transform: translateX(-3px);
  	transform: translateX(-3px);
  	-webkit-transition: -webkit-transform .4s;
  	transition: -webkit-transform .4s;
  	transition: transform .4s;
  	transition: transform .4s, -webkit-transform .4s
  }

  .home-Latestevents-item-text-title-2 {
  	width: 100%;
  	height: 10rem;
  	margin-top: 3.25rem
  }

  .home-Latestevents-item-text-main-2 {
  	width: 100%;
  	height: 10rem;
  	margin-top: 1.25rem
  }

  .home-Latestevents-text-2 {
  	color: #fff;
  	font-size: 1.25rem;
  	margin-left: 100px
  }

  .home-Latestevents-nubmer-2 {
  	margin-top: 3.875rem;
  	float: left
  }

  .home-Latestevents-nubmer-2 span:first-child {
  	font-size: 5rem;
  	font-family: Source Han Sans SC;
  	line-height: 30px;
  	color: #fff;
  	opacity: 1;
  	padding-right: .9375rem;
  	text-align: center;
  	margin-left: 5.5rem
  }

  .home-Latestevents-nubmer-2 span:nth-child(2) {
  	font-size: 36px;
  	font-family: Source Han Sans SC;
  	font-weight: 400;
  	line-height: 30px;
  	color: #fff;
  	opacity: 1;
  	margin-top: -.2rem
  }

  .home-Latestevents-small-white-box-2 {
  	right: 96%
  }

  .home-Latestevents-small-green-box-2,
  .home-Latestevents-small-white-box-2 {
  	width: 4.125rem;
  	height: 4.125rem;
  	position: absolute;
  	top: 50%;
  	margin-top: -2.0625rem;
  	background-color: #fff
  }

  .home-Latestevents-small-green-box-2 {
  	right: 100rem;
  	background-color: #38ab6d
  }

  /* one 最新活动 end */

  /* two 最新活动 start */
  .home-Latestevents-number-item {
  	width: 100rem;
  	height: 34rem;
  	position: relative;
  	margin: 6.5rem auto 3.125rem
  }

  .home-Latestevents-item-image {
  	width: 60.4375rem;
  	height: 100%;
  	background-size: 100% 100%;
  	float: left;
  	overflow: hidden
  }

  .home-Latestevents-item-image img {
  	width: 100%;
  	height: auto;
  	-webkit-transition: all .5s linear;
  	transition: all .5s linear
  }

  .home-Latestevents-item-image img:hover {
  	cursor: default;
  	-webkit-transform: scale(1.2);
  	transform: scale(1.2)
  }

  .home-Latestevents-item-text-b {
  	width: 39.5rem;
  	height: 34rem;
  	float: left;
  	background: #2d2d2d;
  	-webkit-transition: all 5s linear;
  	transition: all 5s linear;
  	overflow: hidden
  }

  .home-Latestevents-item-text {
  	width: 30rem;
  	height: 30rem;
  	overflow: auto;
  	float: left;
  	margin-left: 1.25rem;
  	overflow: hidden
  }

  .home-Latestevents-item-text :hover {
  	-webkit-transform: translateX(3px);
  	transform: translateX(3px);
  	-webkit-transition: -webkit-transform .4s;
  	transition: -webkit-transform .4s;
  	transition: transform .4s;
  	transition: transform .4s, -webkit-transform .4s
  }

  .home-Latestevents-item-text-title {
  	width: 100%;
  	height: 10rem;
  	margin-top: 3.25rem
  }

  .home-Latestevents-item-text-main {
  	width: 100%;
  	height: 10rem;
  	margin-top: 1.25rem;
  	overflow: hidden
  }

  .home-Latestevents-text {
  	color: #fff;
  	font-size: 1.25rem;
  	margin-left: 30px
  }

  .home-Latestevents-nubmer {
  	margin-top: 3.875rem;
  	float: left
  }

  .home-Latestevents-nubmer span:first-child {
  	font-size: 5rem;
  	font-family: Source Han Sans SC;
  	line-height: 30px;
  	color: #fff;
  	opacity: 1;
  	padding-right: .9375rem;
  	text-align: center
  }

  .home-Latestevents-nubmer span:nth-child(2) {
  	font-size: 36px;
  	font-family: Source Han Sans SC;
  	font-weight: 400;
  	line-height: 30px;
  	color: #fff;
  	opacity: 1;
  	margin-top: -.2rem
  }

  .home-Latestevents-small-white-box {
  	right: 0;
  	background-color: #fff
  }

  .home-Latestevents-small-green-box,
  .home-Latestevents-small-white-box {
  	width: 4.125rem;
  	height: 4.125rem;
  	position: absolute;
  	top: 50%;
  	margin-top: -2.0625rem
  }

  .home-Latestevents-small-green-box {
  	right: -4.125rem;
  	background-color: #fff;
  	background: #2d2d2d
  }

  /* two 最新活动 end */
  .product-bntbox {
    width: 100%;
    margin: 4.4375rem 0;
    text-align: center;
  }

  /* 产品与服务 start */
  .home-Productservices-banner1 {
  	width: 100%;
  	min-width: 100%;
  	height: 119.75rem;
  	display: none
  }

  .home-Productservices-banner {
  	width: 100%;
  	min-width: 118rem;
  	height: 42.75rem;
  	background-image: url(../assets/home-image/home-Productservices-banner.jpg);
  	background-size: 100% 100% !important
  }

  .home-Productservices-p1 {
  	-webkit-writing-mode: vertical-rl;
  	-ms-writing-mode: tb-rl;
  	writing-mode: vertical-rl;
  	width: 20px;
  	height: 179px;
  	font-size: 14px;
  	font-family: Source Han Sans SC;
  	font-weight: 700;
  	line-height: 20px;
  	color: #fff;
  	opacity: 1;
  	margin-left: 5px
  }

  .home-Productservices-title {
  	width: 5%;
  	height: 9.5rem;
  	position: relative;
  	top: 27px;
  	left: 1726px;
  	z-index: 999
  }

  .home-Productservices-p2 {
  	-webkit-writing-mode: vertical-rl;
  	-ms-writing-mode: tb-rl;
  	writing-mode: vertical-rl;
  	width: 26px;
  	height: 190px;
  	font-size: 26px;
  	font-family: Source Han Sans SC;
  	font-weight: 400;
  	line-height: 38px;
  	color: #fff;
  	opacity: 1;
  	float: left;
  	margin-left: 15px
  }

  .home-Productservices-title2 {
  	display: none;
  	width: 33%;
  	height: 6.5rem;
  	position: relative;
  	top: 27px;
  	left: 20px;
  	z-index: 999
  }

  .home-Productservices-p4 {
  	height: 43px;
  	font-size: 30px;
  	font-weight: 400;
  	line-height: 38px;
  	float: left
  }

  .home-Productservices-p3,
  .home-Productservices-p4 {
  	width: 100%;
  	font-family: Source Han Sans SC;
  	color: #fff;
  	opacity: 1;
  	margin-left: 5px;
  	display: none
  }

  .home-Productservices-p3 {
  	height: 67px;
  	font-size: 14px;
  	font-weight: 700;
  	line-height: 20px;
  	z-index: 99999
  }

  .home-Productservices-box1 {
  	width: 1469px;
  	height: 307px;
  	background: #fff;
  	position: relative;
  	top: 0;
  	left: 100px;
  	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  	box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
  }

  .home-Productservices-box1-ron {
  	width: 95%;
  	height: 307px;
  	margin: 0 auto;
  	overflow: hidden
  }

  .home-Productservices-box1-ron :hover {
  	-webkit-transform: translateY(-8px);
  	transform: translateY(-8px);
  	-webkit-transition: -webkit-transform .5s;
  	transition: -webkit-transform .5s;
  	transition: transform .5s;
  	transition: transform .5s, -webkit-transform .5s
  }

  .home-Productservices-box1-ron-con1 {
  	width: 33%;
  	height: 307px;
  	float: left;
  	overflow: hidden
  }

  .home-Productservices-box1-ron-con2,
  .home-Productservices-box1-ron-con3 {
  	width: 33%;
  	height: 307px;
  	float: left
  }

  .home-Productservices-box1-ron-con1-imtx {
  	width: 100%;
  	height: 205px
  }

  .home-Productservices-App-img {
  	width: 32px;
  	height: 47px;
  	opacity: 1;
  	padding-top: 94px;
  	padding-left: 205px
  }

  .home-Productservices-wx-img {
  	width: 50px;
  	height: 47px;
  	opacity: 1;
  	padding-top: 94px;
  	padding-left: 205px
  }

  .home-Productservices-wifi-img {
  	width: 68px;
  	height: 47px;
  	opacity: 1;
  	padding-top: 94px;
  	padding-left: 205px
  }

  .home-Productservices-saas-img {
  	width: 60px;
  	height: 47px;
  	opacity: 1;
  	padding-top: 94px;
  	padding-left: 205px
  }

  .home-Productservices-wechat-img {
  	width: 57px;
  	height: 47px;
  	opacity: 1;
  	padding-top: 94px;
  	padding-left: 205px
  }

  .home-Productservices-teach-img {
  	width: 60px;
  	height: 47px;
  	opacity: 1;
  	padding-top: 94px;
  	padding-left: 205px
  }

  .home-Productservices-wechat {
  	width: 203px;
  	padding-left: 123px
  }

  .home-Productservices-App,
  .home-Productservices-wechat {
  	height: 33px;
  	font-size: 22px;
  	font-family: Source Han Sans SC;
  	font-weight: 500;
  	line-height: 18px;
  	color: #39ab6d;
  	opacity: 1;
  	line-height: 50px
  }

  .home-Productservices-App {
  	width: 132px;
  	padding-left: 155px
  }

  .home-Productservices-wifi {
  	width: 265px;
  	padding-left: 108px
  }

  .home-Productservices-saas,
  .home-Productservices-wifi {
  	height: 33px;
  	font-size: 22px;
  	font-family: Source Han Sans SC;
  	font-weight: 500;
  	line-height: 18px;
  	color: #39ab6d;
  	opacity: 1;
  	line-height: 50px
  }

  .home-Productservices-saas {
  	width: 153px;
  	padding-left: 167px
  }

  .home-Productservices-weat {
  	width: 98px;
  	padding-left: 185px
  }

  .home-Productservices-teach,
  .home-Productservices-weat {
  	height: 33px;
  	font-size: 22px;
  	font-family: Source Han Sans SC;
  	font-weight: 500;
  	line-height: 18px;
  	color: #39ab6d;
  	opacity: 1;
  	line-height: 50px
  }

  .home-Productservices-teach {
  	width: 180px;
  	padding-left: 148px
  }

  .home-Productservices-box1-ron-con1-text {
  	width: 100%;
  	height: 100px
  }

  .home-Productservices-box1-ron-con1-text p {
  	width: 381px;
  	height: 66px;
  	font-size: 16px;
  	font-family: Source Han Sans SC;
  	font-weight: 400;
  	line-height: 24px;
  	color: #333;
  	opacity: 1;
  	text-align: center;
  	padding-left: 37px
  }

  .home-Productservices-box2 {
  	width: 1469px;
  	height: 307px;
  	background: #fff;
  	position: relative;
  	top: 76px;
  	left: 300px;
  	-webkit-box-shadow: 3px 3px 9px rgba(0, 0, 0, .16);
  	box-shadow: 3px 3px 9px rgba(0, 0, 0, .16);
  	overflow: hidden
  }

  .home-Productservices-box2-ron {
  	width: 95%;
  	height: 307px;
  	margin: 0 auto;
  	overflow: hidden
  }

  .home-Productservices-box2-ron :hover {
  	-webkit-transform: translateY(-8px);
  	transform: translateY(-8px);
  	-webkit-transition: -webkit-transform .5s;
  	transition: -webkit-transform .5s;
  	transition: transform .5s;
  	transition: transform .5s, -webkit-transform .5s
  }

  .product-bntboxtwo {
  	width: 100%;
  	margin: 15rem 0 7.0625rem;
  	text-align: center
  }

  /* 产品与服务 end */
  /* 合作案例 start */
  .home-Cooperaprog-banner1 {
  	width: 100%;
  	min-width: 100%;
  	height: 95.8125rem;
  	display: none
  }

  .home-Cooperaprog-banner {
  	width: 100%;
  	min-width: 118rem;
  	height: 63.8125rem;
  	background-image: url(../assets/home-image/Cooperaprogbanner.jpg);
  	background-size: 100% 100% !important
  }

  .home-Cooperaprog-title {
  	width: 5%;
  	height: 9.5rem;
  	position: relative;
  	top: 72px;
  	left: 80px;
  	z-index: 999
  }

  .home-Cooperaprog-p1 {
  	width: 20px;
  	height: 148px;
  	font-size: 14px;
  	font-weight: 700;
  	line-height: 20px;
  	margin-left: 5px
  }

  .home-Cooperaprog-p1,
  .home-Cooperaprog-p2 {
  	-webkit-writing-mode: vertical-rl;
  	-ms-writing-mode: tb-rl;
  	writing-mode: vertical-rl;
  	font-family: Source Han Sans SC;
  	color: #fff;
  	opacity: 1;
  	float: left
  }

  .home-Cooperaprog-p2 {
  	width: 26px;
  	height: 152px;
  	font-size: 26px;
  	font-weight: 400;
  	line-height: 38px;
  	margin-left: 15px
  }

  .home-Cooperaprog-title2 {
  	width: 5%;
  	height: 9.5rem;
  	position: relative;
  	top: 72px;
  	left: 80px;
  	z-index: 999;
  	display: none
  }

  .home-Cooperaprog-p3 {
  	width: 20px;
  	height: 148px;
  	font-size: 14px;
  	font-weight: 700;
  	line-height: 20px;
  	margin-left: 5px
  }

  .home-Cooperaprog-p3,
  .home-Cooperaprog-p4 {
  	font-family: Source Han Sans SC;
  	color: #fff;
  	opacity: 1;
  	float: left
  }

  .home-Cooperaprog-p4 {
  	width: 26px;
  	height: 152px;
  	font-size: 26px;
  	font-weight: 400;
  	line-height: 38px;
  	margin-left: 15px
  }

  .home-Cooperaprog-box1 {
  	width: 90.625rem;
  	height: 31.5625rem;
  	position: relative;
  	top: -73px;
  	left: 285px
  }

  .home-Cooperaprog-box1-ron {
  	width: 95%;
  	height: 31.5625rem;
  	margin: 0 auto
  }

  .home-Cooperaprog-box1-one {
  	width: 31%;
  	height: 31.5625rem;
  	float: left;
  	margin-right: 3.5%;
  	background: #4a4949;
  	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  	box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
  }

  .home-Cooperaprog-box1-ron :hover {
  	background-color: #39ab6d;
  	-webkit-transition: background-color 1s;
  	transition: background-color 1s
  }

  .home-Cooperaprog-box1-one-botton .el-button:hover {
  	background: #39ab6d
  }

  .home-Cooperaprog-box1-one-imtx {
  	width: 100%;
  	height: 13.125rem
  }

  .home-Cooperaprog-box1-one-imtx img {
  	width: 121px;
  	height: 121px;
  	border: 1px solid #707070;
  	border-radius: 50%;
  	opacity: 1;
  	margin: 25px 92px 25px 148px
  }

  .home-Cooperaprog-box1-huining {
  	margin-left: 156px
  }

  .home-Cooperaprog-box1-donghua,
  .home-Cooperaprog-box1-huining {
  	width: 100px;
  	height: 29px;
  	font-size: 20px;
  	font-family: Source Han Sans SC;
  	font-weight: 400;
  	line-height: 29px;
  	color: #fff;
  	opacity: 1
  }

  .home-Cooperaprog-box1-donghua {
  	margin-left: 169px
  }

  .home-Cooperaprog-box1-antuo,
  .home-Cooperaprog-box1-menghuang {
  	width: 120px
  }

  .home-Cooperaprog-box1-antuo,
  .home-Cooperaprog-box1-jingcheng,
  .home-Cooperaprog-box1-menghuang {
  	height: 29px;
  	font-size: 20px;
  	font-family: Source Han Sans SC;
  	font-weight: 400;
  	line-height: 29px;
  	color: #fff;
  	opacity: 1;
  	margin-left: 169px
  }

  .home-Cooperaprog-box1-jingcheng {
  	width: 100px
  }

  .home-Cooperaprog-box1-one-text {
  	width: 100%;
  	height: 11.875rem
  }

  .home-Cooperaprog-box1-one-text p {
  	width: 307px;
  	height: 120px;
  	font-size: 16px;
  	font-family: Source Han Sans SC;
  	font-weight: 400;
  	line-height: 24px;
  	color: #fff;
  	opacity: 1;
  	padding-left: 2.75rem;
  	padding-top: 1.25rem
  }

  .home-Cooperaprog-box1-one-bigbotton {
  	width: 100%;
  	height: 2.5rem;
  	margin-top: .5625rem
  }

  .home-Cooperaprog-box1-one-botton {
  	width: 100%;
  	text-align: center
  }

  .home-Cooperaprog-box1-one-botton .el-button {
  	background: #4a4949;
  	border: 1px solid #fff;
  	color: #fff
  }

  .el-button:hover,
  .home-Cooperaprog-box1-one-botton .el-button:focus {
  	background: #39ab6d;
  	border: 1px solid #fff;
  	color: #fff
  }

  .home-Cooperaprog-box1-one-botton2 {
  	width: 100%;
  	text-align: center
  }

  .home-Cooperaprog-box1-one-botton2 .el-button {
  	background: #4a4949;
  	border: 1px solid #fff;
  	color: #fff
  }

  .home-Cooperaprog-box1-one-botton2 .el-button:hover {
  	background: #39ab6d
  }

  .el-button:hover,
  .home-Cooperaprog-box1-one-botton2 .el-button:focus {
  	background: #4a4949;
  	border: 1px solid #fff;
  	color: #fff
  }

  .home-Cooperaprog-box1-two {
  	float: left
  }

  .home-Cooperaprog-box1-three,
  .home-Cooperaprog-box1-two {
  	width: 31%;
  	height: 31.5625rem;
  	background: #4a4949;
  	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  	box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
  }

  .home-Cooperaprog-box1-three {
  	float: right
  }

  .home-Cooperaprog-box2 {
  	width: 90.625rem;
  	height: 31.5625rem;
  	position: relative;
  	top: -10px;
  	left: 88px
  }

  .home-Cooperaprog-box2-ron {
  	width: 95%;
  	height: 31.5625rem;
  	margin: 0 auto
  }

  .home-Cooperaprog-box2-ron :hover {
  	background-color: #39ab6d;
  	-webkit-transition: background-color 1s;
  	transition: background-color 1s
  }

  .home-Cooperaprog-box2-one {
  	margin-right: 3.5%
  }

  .home-Cooperaprog-box2-one,
  .home-Cooperaprog-box2-two {
  	float: left
  }

  .home-Cooperaprog-box2-one,
  .home-Cooperaprog-box2-three,
  .home-Cooperaprog-box2-two {
  	width: 31%;
  	height: 31.5625rem;
  	background: #4a4949;
  	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  	box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
  }

  .home-Cooperaprog-box2-three {
  	float: right
  }

  /* 合作案例 end */
  /* 关于我们 start */
  .home-Aboutus-banner {
  	width: 100%;
  	min-width: 118rem;
  	height: 43.5625rem;
  	background-image: url(/static/img/aboutbackimg.951fd05.png);
  	background-size: 100% 100% !important
  }

  /* 关于我们标题 */
 .home-Aboutus-title {
 	width: 5%;
 	height: 9.5rem;
 	z-index: 999;
 	position: relative;
 	top: 56px;
 	left: 100px
 }

 .home-Aboutus-p1 {
 	width: 20px;
 	height: 148px;
 	font-size: 14px;
 	font-weight: 700;
 	line-height: 20px;
 	margin-left: 5px
 }

 .home-Aboutus-p1,
 .home-Aboutus-p2 {
 	-webkit-writing-mode: vertical-rl;
 	-ms-writing-mode: tb-rl;
 	writing-mode: vertical-rl;
 	font-family: Source Han Sans SC;
 	color: #fff;
 	opacity: 1;
 	float: left
 }

 .home-Aboutus-p2 {
 	width: 26px;
 	height: 152px;
 	font-size: 26px;
 	font-weight: 400;
 	line-height: 38px;
 	margin-left: 15px
 }

 .home-Aboutus-title2 {
 	width: 5%;
 	height: 9.5rem;
 	z-index: 999;
 	position: relative;
 	top: 56px;
 	left: 100px;
 	display: none
 }

 .home-Aboutus-p3 {
 	width: 20px;
 	height: 148px;
 	font-size: 14px;
 	font-weight: 700;
 	line-height: 20px;
 	margin-left: 5px
 }

 .home-Aboutus-p3,
 .home-Aboutus-p4 {
 	font-family: Source Han Sans SC;
 	color: #fff;
 	opacity: 1;
 	float: left
 }

 .home-Aboutus-p4 {
 	width: 26px;
 	height: 152px;
 	font-size: 26px;
 	font-weight: 400;
 	line-height: 38px;
 	margin-left: 15px
 }

.home-Aboutus-con {
	width: 45.3125rem;
	height: 5.5625rem;
	position: relative;
	top: 160px;
	left: 600px
}

.home-Aboutus-con:hover {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
	-webkit-transition: -webkit-transform .6s;
	transition: -webkit-transform .6s;
	transition: transform .6s;
	transition: transform .6s, -webkit-transform .6s
}

.home-Aboutus-con p {
	width: 725px;
	height: 89px;
	font-size: 20px;
	font-family: Source Han Sans SC;
	font-weight: 400;
	line-height: 30px;
	color: #fff;
	opacity: 1
}

.home-Aboutus-botton {
	width: 100%;
	margin: 18rem 0 7.0625rem;
	text-align: center
}

.home-Aboutus-botton .el-button {
	border: 1px solid #fff;
	background-color: transparent;
	color: #fff
}

  /* 关于我们标题 */
  /* 关于我们 end */
  /* 媒体查询 小于100rem */
  @media screen and (max-width: 100rem) {

    /* 最新活动标题 */
    .home-Latestevents-title {
    	width: 7%;
    	height: 9.5rem;
    	position: relative;
    	top: 153px;
    	left: 50px;
    	z-index: 999
    }

    .home-Latestevents-p1 {
    	width: 20px;
    	height: 115px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	margin-left: 5px
    }

    .home-Latestevents-p1,
    .home-Latestevents-p2 {
    	-webkit-writing-mode: vertical-rl;
    	-ms-writing-mode: tb-rl;
    	writing-mode: vertical-rl;
    	font-family: Source Han Sans SC;
    	color: #333;
    	opacity: 1;
    	float: left
    }

    .home-Latestevents-p2 {
    	width: 26px;
    	height: 152px;
    	font-size: 26px;
    	font-weight: 400;
    	line-height: 38px;
    	margin-left: 15px
    }

    /* one 最新活动 start */
    .home-Latestevents-number-item-2 {
    	width: 100%;
    	height: 34rem;
    	position: relative;
    	margin: 3.125rem auto 3.125rem 8rem
    }

    .home-Latestevents-item-image-2 {
    	width: 60%;
    	height: 100%;
    	background-size: 100% 100%;
    	float: left
    }

    .home-Latestevents-item-image-2 img {
    	width: 100%;
    	height: auto
    }

    .home-Latestevents-item-text-b-2 {
    	width: 40%;
    	height: 34rem;
    	float: left;
    	background-color: #27cbbd
    }

    .home-Latestevents-item-text-2 {
    	width: 30rem;
    	height: 30rem;
    	overflow: auto;
    	float: left;
    	margin-left: 1.25rem
    }

    .home-Latestevents-item-text-title-2 {
    	width: 100%;
    	height: 10rem;
    	margin-top: 3.25rem
    }

    .home-Latestevents-item-text-main-2 {
    	width: 100%;
    	height: 10rem;
    	margin-top: 1.25rem
    }

    .home-Latestevents-text-2 {
    	color: #fff;
    	font-size: 1.25rem;
    	margin-left: 100px
    }

    .home-Latestevents-nubmer-2 {
    	margin-top: 3.875rem;
    	float: left
    }

    .home-Latestevents-nubmer-2 span:first-child {
    	font-size: 5rem;
    	font-family: Source Han Sans SC;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	padding-right: .9375rem;
    	text-align: center;
    	margin-left: 5.5rem
    }

    .home-Latestevents-nubmer-2 span:nth-child(2) {
    	font-size: 36px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	margin-top: -.2rem
    }

    .home-Latestevents-small-white-box-2 {
    	right: 96%
    }

    .home-Latestevents-small-green-box-2,
    .home-Latestevents-small-white-box-2 {
    	width: 4.125rem;
    	height: 4.125rem;
    	position: absolute;
    	top: 50%;
    	margin-top: -2.0625rem;
    	background-color: #fff
    }

    .home-Latestevents-small-green-box-2 {
    	right: 100%;
    	background-color: #38ab6d
    }

    /* one 最新活动 end */
    /* two 最新活动 start */
    .home-Latestevents-number-item {
    	width: 100%;
    	height: 34rem;
    	position: relative;
    	margin: 6.5rem auto 3.125rem 8rem
    }

    .home-Latestevents-item-image {
    	width: 60%;
    	height: 100%;
    	background-size: 100% 100%;
    	float: left
    }

    .home-Latestevents-item-image img {
    	width: 100%;
    	height: auto
    }

    .home-Latestevents-item-text-b {
    	width: 40%;
    	height: 34rem;
    	float: left;
    	background: #2d2d2d
    }

    .home-Latestevents-item-text {
    	width: 30rem;
    	height: 30rem;
    	overflow: auto;
    	float: left;
    	margin-left: 1.25rem
    }

    .home-Latestevents-item-text-title {
    	width: 100%;
    	height: 10rem;
    	margin-top: 3.25rem
    }

    .home-Latestevents-item-text-main {
    	width: 100%;
    	height: 10rem;
    	margin-top: 1.25rem
    }

    .home-Latestevents-text {
    	color: #fff;
    	font-size: 1.25rem;
    	margin-left: 30px
    }

    .home-Latestevents-nubmer {
    	margin-top: 3.875rem;
    	float: left
    }

    .home-Latestevents-nubmer span:first-child {
    	font-size: 5rem;
    	font-family: Source Han Sans SC;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	padding-right: .9375rem;
    	text-align: center
    }

    .home-Latestevents-nubmer span:nth-child(2) {
    	font-size: 36px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	margin-top: -.2rem
    }

    .home-Latestevents-small-white-box {
    	right: 0;
    	background-color: #fff
    }

    .home-Latestevents-small-green-box,
    .home-Latestevents-small-white-box {
    	width: 4.125rem;
    	height: 4.125rem;
    	position: absolute;
    	top: 50%;
    	margin-top: -2.0625rem
    }

    .home-Latestevents-small-green-box {
    	right: -4.125rem;
    	background-color: #fff;
    	background: #2d2d2d
    }
    /* two 最新活动 end */
    .product-bntbox {
      width: 100%;
      margin: 4.4375rem 0;
      text-align: center;
    }

    /* 产品与服务 start */
    .home-Productservices-banner1 {
    	width: 100%;
    	min-width: 100%;
    	height: 119.75rem;
    	display: none
    }

    .home-Productservices-banner {
    	width: 100%;
    	min-width: 100%;
    	height: 42.75rem;
    	background-image: url(../assets/home-image/home-Productservices-banner.jpg);
    	background-size: 100% 100% !important
    }

    .home-Productservices-title {
    	width: 5%;
    	height: 9.5rem;
    	position: relative;
    	top: 27px;
    	left: 1726px;
    	z-index: 999
    }

    .home-Productservices-p1 {
    	width: 20px;
    	height: 179px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	margin-left: 5px
    }

    .home-Productservices-p1,
    .home-Productservices-p2 {
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1
    }

    .home-Productservices-p2 {
    	width: 26px;
    	height: 190px;
    	font-size: 26px;
    	font-weight: 400;
    	line-height: 38px;
    	float: left;
    	margin-left: 15px
    }

    .home-Productservices-box1 {
    	width: 1469px;
    	height: 307px;
    	background: #fff;
    	position: relative;
    	top: 0;
    	left: 100px;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
    }

    .home-Productservices-box1-ron {
    	width: 95%;
    	height: 307px;
    	margin: 0 auto
    }

    .home-Productservices-box1-ron-con1,
    .home-Productservices-box1-ron-con2,
    .home-Productservices-box1-ron-con3 {
    	width: 33%;
    	height: 307px;
    	float: left
    }

    .home-Productservices-box1-ron-con1-imtx {
    	width: 100%;
    	height: 205px
    }

    .home-Productservices-App-img {
    	width: 32px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 94px;
    	padding-left: 205px
    }

    .home-Productservices-wx-img {
    	width: 50px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 94px;
    	padding-left: 205px
    }

    .home-Productservices-wifi-img {
    	width: 68px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 94px;
    	padding-left: 205px
    }

    .home-Productservices-saas-img {
    	width: 60px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 94px;
    	padding-left: 205px
    }

    .home-Productservices-wechat-img {
    	width: 57px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 94px;
    	padding-left: 205px
    }

    .home-Productservices-teach-img {
    	width: 60px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 94px;
    	padding-left: 205px
    }

    .home-Productservices-wechat {
    	width: 203px;
    	padding-left: 123px
    }

    .home-Productservices-App,
    .home-Productservices-wechat {
    	height: 33px;
    	font-size: 22px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	line-height: 18px;
    	color: #39ab6d;
    	opacity: 1;
    	line-height: 50px
    }

    .home-Productservices-App {
    	width: 132px;
    	padding-left: 155px
    }

    .home-Productservices-wifi {
    	width: 265px;
    	padding-left: 108px
    }

    .home-Productservices-saas,
    .home-Productservices-wifi {
    	height: 33px;
    	font-size: 22px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	line-height: 18px;
    	color: #39ab6d;
    	opacity: 1;
    	line-height: 50px
    }

    .home-Productservices-saas {
    	width: 153px;
    	padding-left: 167px
    }

    .home-Productservices-weat {
    	width: 98px;
    	padding-left: 185px
    }

    .home-Productservices-teach,
    .home-Productservices-weat {
    	height: 33px;
    	font-size: 22px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	line-height: 18px;
    	color: #39ab6d;
    	opacity: 1;
    	line-height: 50px
    }

    .home-Productservices-teach {
    	width: 180px;
    	padding-left: 148px
    }

    .home-Productservices-box1-ron-con1-text {
    	width: 100%;
    	height: 100px
    }

    .home-Productservices-box1-ron-con1-text p {
    	width: 381px;
    	height: 66px;
    	font-size: 16px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 24px;
    	color: #333;
    	opacity: 1;
    	text-align: center;
    	padding-left: 37px
    }

    .home-Productservices-box2 {
    	width: 1469px;
    	height: 307px;
    	background: #fff;
    	position: relative;
    	top: 76px;
    	left: 300px;
    	-webkit-box-shadow: 3px 3px 9px rgba(0, 0, 0, .16);
    	box-shadow: 3px 3px 9px rgba(0, 0, 0, .16)
    }

    .home-Productservices-box2-ron {
    	width: 95%;
    	height: 307px;
    	margin: 0 auto
    }

    .product-bntboxtwo {
    	width: 100%;
    	min-width: 115rem;
    	margin: 15rem 0 7.0625rem;
    	text-align: center
    }

    /* 产品与服务 end */
    /* 合作案例 start */
    .home-Cooperaprog-banner1 {
    	width: 100%;
    	min-width: 100%;
    	height: 95.8125rem;
    	display: none
    }

    .home-Cooperaprog-banner {
    	height: 63.8125rem;
    	background-image: url(../assets/home-image/Cooperaprogbanner.jpg);
    }

    /* 合作案例 end */
    /* 关于我们 start */
   .home-Aboutus-banner,
   .home-Cooperaprog-banner {
   	width: 100%;
   	min-width: 100%;
   	background-size: 100% 100% !important
   }

   .home-Aboutus-banner {
   	height: 43.5625rem;
   	background-image: url(/static/img/aboutbackimg.951fd05.png)
   }

    /* 关于我们 end */
  }

  /* 媒体查询 小于62rem */
  @media screen and (max-width: 62rem) {

    /* 最新活动标题 */
    .home-Latestevents-title {
    	width: 15%;
    	height: 9.5rem;
    	position: relative;
    	top: 70px;
    	left: 50px;
    	z-index: 999;
    	display: none
    }

    .home-Latestevents-p1 {
    	width: 20px;
    	height: 115px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	margin-left: 5px
    }

    .home-Latestevents-p1,
    .home-Latestevents-p2 {
    	font-family: Source Han Sans SC;
    	color: #333;
    	opacity: 1;
    	float: left
    }

    .home-Latestevents-p2 {
    	width: 26px;
    	height: 152px;
    	font-size: 26px;
    	font-weight: 400;
    	line-height: 38px;
    	margin-left: 15px
    }

    .home-Latestevents-title2 {
    	width: 30%;
    	height: 8.5rem;
    	position: relative;
    	top: 160px;
    	left: 350px;
    	z-index: 999;
    	display: block
    }

    .home-Latestevents-p3 {
    	width: 151px;
    	height: 76px;
    	font-size: 17px;
    	font-weight: 700;
    	line-height: 20px
    }

    .home-Latestevents-p3,
    .home-Latestevents-p4 {
    	font-family: Source Han Sans SC;
    	color: #333;
    	opacity: 1;
    	float: left;
    	margin-left: 15px;
    	text-align: center
    }

    .home-Latestevents-p4 {
    	width: 160px;
    	height: 41px;
    	font-size: 31px;
    	font-weight: 400;
    	line-height: 38px;
    	margin-bottom: 5px
    }

    /* one 最新活动 start */
    .home-Latestevents-number-item-2 {
    	width: 100%;
    	min-width: 100%;
    	height: 34rem;
    	margin: 3.125rem auto;
    	position: relative
    }

    .home-Latestevents-item-image-2 {
    	width: 100%;
    	min-width: 100%;
    	height: auto;
    	background-size: 100% 100%;
    	float: left
    }

    .home-Latestevents-item-image-2 img {
    	width: 100%;
    	height: auto
    }

    .home-Latestevents-item-text-b-2 {
    	width: 100%;
    	min-width: 100%;
    	height: 34rem;
    	float: left;
    	background-color: #27cbbd
    }

    .home-Latestevents-item-text-2 {
    	width: 97%;
    	min-width: 98%;
    	height: 30rem;
    	overflow: auto;
    	float: left;
    	margin-left: 1.25rem
    }

    .home-Latestevents-item-text-title-2 {
    	width: 100%;
    	height: 10rem;
    	margin-top: 3.25rem
    }

    .home-Latestevents-item-text-main-2 {
    	width: 100%;
    	min-width: 100%;
    	height: 10rem;
    	margin-top: 1.25rem
    }

    .home-Latestevents-text-2 {
    	width: 80%;
    	min-width: 80%;
    	color: #fff;
    	font-size: 1.5rem;
    	margin-left: 100px
    }

    .home-Latestevents-nubmer-2 {
    	margin-top: 3.875rem;
    	float: left
    }

    .home-Latestevents-nubmer-2 span:first-child {
    	font-size: 5rem;
    	font-family: Source Han Sans SC;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	padding-right: .9375rem;
    	text-align: center;
    	margin-left: 5.5rem
    }

    .home-Latestevents-nubmer-2 span:nth-child(2) {
    	font-size: 36px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	margin-top: -.2rem
    }

    .home-Latestevents-small-white-box-2 {
    	right: 96%
    }

    .home-Latestevents-small-green-box-2,
    .home-Latestevents-small-white-box-2 {
    	width: 4.125rem;
    	height: 4.125rem;
    	position: absolute;
    	top: 50%;
    	margin-top: -2.0625rem;
    	background-color: #fff;
    	display: none
    }

    .home-Latestevents-small-green-box-2 {
    	right: 100rem;
    	background-color: #38ab6d
    }

    /* one 最新活动 end */
    /* two 最新活动 start */
    .home-Latestevents-number-item {
    	width: 100%;
    	min-width: 100%;
    	height: 34rem;
    	position: relative;
    	margin: 6.5rem auto 3.125rem
    }

    .home-Latestevents-item-image {
    	width: 100%;
    	min-width: 100%;
    	height: auto;
    	background-size: 100% 100%;
    	float: left
    }

    .home-Latestevents-item-image img {
    	width: 100%;
    	height: auto
    }

    .home-Latestevents-item-text-b {
    	width: 100%;
    	min-width: 100%;
    	height: 34rem;
    	float: left;
    	background: #2d2d2d
    }

    .home-Latestevents-item-text {
    	width: 97%;
    	min-width: 98%;
    	height: 30rem;
    	overflow: auto;
    	float: left
    }

    .home-Latestevents-item-text-title {
    	width: 100%;
    	height: 10rem;
    	margin-top: 3.25rem
    }

    .home-Latestevents-item-text-main {
    	width: 100%;
    	min-width: 100%;
    	height: 10rem;
    	margin-top: 1.25rem
    }

    .home-Latestevents-text {
    	width: 80%;
    	min-width: 80%;
    	color: #fff;
    	font-size: 1.5rem;
    	margin-left: 73px
    }

    .home-Latestevents-nubmer {
    	margin-top: 3.875rem;
    	float: left
    }

    .home-Latestevents-nubmer span:first-child {
    	font-size: 5rem;
    	font-family: Source Han Sans SC;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	padding-right: .9375rem;
    	text-align: center;
    	margin-left: 67px
    }

    .home-Latestevents-nubmer span:nth-child(2) {
    	font-size: 36px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	margin-top: -.2rem
    }

    .home-Latestevents-small-white-box {
    	right: 0;
    	background-color: #fff
    }

    .home-Latestevents-small-green-box,
    .home-Latestevents-small-white-box {
    	width: 4.125rem;
    	height: 4.125rem;
    	position: absolute;
    	top: 50%;
    	margin-top: -2.0625rem;
    	display: none
    }

    .home-Latestevents-small-green-box {
    	right: -4.125rem;
    	background-color: #fff;
    	background: #2d2d2d
    }

    /* two 最新活动 end */
    .product-bntbox {
    	width: 100%;
    	margin: 4.4375rem 0;
    	text-align: center
    }

    /* 产品与服务 start */
    .home-Productservices-banner1 {
    	width: 100%;
    	min-width: 100%;
    	height: 119.75rem;
    	display: none
    }

    .home-Productservices-banner {
    	width: 100%;
    	min-width: 100%;
    	height: 42.75rem;
    	background-image: url(../assets/home-image/home-Productservices-banner.jpg);
    	background-size: 100% 100% !important
    }

    .home-Productservices-title {
    	width: 33%;
    	height: 6.5rem;
    	position: relative;
    	top: 27px;
    	left: 20px;
    	z-index: 999;
    	display: none
    }

    .home-Productservices-p2 {
    	height: 43px;
    	font-size: 30px;
    	font-weight: 400;
    	line-height: 38px;
    	float: left
    }

    .home-Productservices-p1,
    .home-Productservices-p2 {
    	width: 100%;
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1;
    	margin-left: 5px
    }

    .home-Productservices-p1 {
    	height: 67px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	z-index: 99999
    }

    .home-Productservices-title2 {
    	display: block;
    	width: 33%;
    	height: 6.5rem;
    	position: relative;
    	top: 27px;
    	left: 20px;
    	z-index: 999
    }

    .home-Productservices-p4 {
    	height: 43px;
    	font-size: 30px;
    	font-weight: 400;
    	line-height: 38px;
    	float: left
    }

    .home-Productservices-p3,
    .home-Productservices-p4 {
    	width: 100%;
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1;
    	margin-left: 5px;
    	display: block
    }

    .home-Productservices-p3 {
    	height: 67px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	z-index: 99999
    }

    .home-Productservices-box1 {
    	width: 100%;
    	min-width: 100%;
    	height: 275px;
    	background: #fff;
    	position: relative;
    	top: 0;
    	left: 0;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
    }

    .home-Productservices-box1-ron {
    	width: 95%;
    	height: 275px;
    	margin: 0 auto
    }

    .home-Productservices-box1-ron-con1 {
    	width: 30%;
    	height: 244px;
    	float: left;
    	margin-right: 20px
    }

    .home-Productservices-box1-ron-con2 {
    	width: 30%;
    	height: 244px;
    	float: left;
    	margin-right: 35px
    }

    .home-Productservices-box1-ron-con3 {
    	width: 30%;
    	height: 244px;
    	float: left
    }

    .home-Productservices-box1-ron-con1-imtx {
    	width: 100%;
    	height: 138px
    }

    .home-Productservices-App-img {
    	width: 32px;
    	height: 46px;
    	opacity: 1;
    	padding-top: 37px;
    	padding-left: 123px
    }

    .home-Productservices-wx-img {
    	width: 50px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 35px;
    	padding-left: 114px
    }

    .home-Productservices-wifi-img {
    	width: 68px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 34px;
    	padding-left: 93px
    }

    .home-Productservices-saas-img {
    	width: 60px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 33px;
    	padding-left: 116px
    }

    .home-Productservices-wechat-img {
    	width: 57px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 26px;
    	padding-left: 110px
    }

    .home-Productservices-teach-img {
    	width: 60px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 20px;
    	padding-left: 112px
    }

    .home-Productservices-wechat {
    	padding-left: 41px
    }

    .home-Productservices-App,
    .home-Productservices-wechat {
    	width: 100%;
    	height: 33px;
    	font-size: 22px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	line-height: 18px;
    	color: #39ab6d;
    	opacity: 1;
    	line-height: 50px
    }

    .home-Productservices-App {
    	padding-left: 73px
    }

    .home-Productservices-wifi {
    	padding-left: 13px
    }

    .home-Productservices-saas,
    .home-Productservices-wifi {
    	width: 100%;
    	height: 33px;
    	font-size: 22px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	line-height: 18px;
    	color: #39ab6d;
    	opacity: 1;
    	line-height: 50px
    }

    .home-Productservices-saas {
    	padding-left: 72px
    }

    .home-Productservices-weat {
    	line-height: 18px;
    	line-height: 50px;
    	padding-left: 96px
    }

    .home-Productservices-teach,
    .home-Productservices-weat {
    	width: 100%;
    	height: 33px;
    	font-size: 22px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	color: #39ab6d;
    	opacity: 1
    }

    .home-Productservices-teach {
    	line-height: 18px;
    	line-height: 62px;
    	padding-left: 56px
    }

    .home-Productservices-box1-ron-con1-text {
    	width: 100%;
    	height: 100px
    }

    .home-Productservices-box1-ron-con1-text p {
    	width: 100%;
    	height: auto;
    	font-size: 15px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 24px;
    	color: #333;
    	opacity: 1;
    	text-align: center;
    	padding-left: 0
    }

    .home-Productservices-box2 {
    	width: 100%;
    	height: 275px;
    	background: #fff;
    	position: relative;
    	top: 76px;
    	left: 0;
    	-webkit-box-shadow: 3px 3px 9px rgba(0, 0, 0, .16);
    	box-shadow: 3px 3px 9px rgba(0, 0, 0, .16)
    }

    .home-Productservices-box2-ron {
    	width: 95%;
    	height: 275px;
    	margin: 0 auto
    }

    .product-bntboxtwo {
    	width: 100%;
    	min-width: 100%;
    	margin: 10rem 0 7.0625rem;
    	text-align: center
    }

    /* 产品与服务 end */
    /* 合作案例 start */
    .home-Cooperaprog-banner1 {
    	width: 100%;
    	min-width: 100%;
    	height: 95.8125rem;
    	display: none
    }

    .home-Cooperaprog-banner {
    	width: 100%;
    	min-width: 100%;
    	height: 63.8125rem;
    	background-image: url(../assets/home-image/Cooperaprogbanner.jpg);
    	background-size: 100% 100% !important
    }

    /* 合作案例标题 */
    .home-Cooperaprog-title {
    	width: 5%;
    	height: 9.5rem;
    	position: relative;
    	top: 72px;
    	left: 80px;
    	z-index: 999;
    	display: none
    }

    .home-Cooperaprog-p1 {
    	width: 20px;
    	height: 148px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	margin-left: 5px
    }

    .home-Cooperaprog-p1,
    .home-Cooperaprog-p2 {
    	-webkit-writing-mode: vertical-rl;
    	-ms-writing-mode: tb-rl;
    	writing-mode: vertical-rl;
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1;
    	float: left
    }

    .home-Cooperaprog-p2 {
    	width: 26px;
    	height: 152px;
    	font-size: 26px;
    	font-weight: 400;
    	line-height: 38px;
    	margin-left: 15px
    }

    .home-Cooperaprog-title2 {
    	width: 17%;
    	height: 6.5rem;
    	position: relative;
    	top: 41px;
    	left: 63px;
    	z-index: 999;
    	display: block
    }

    .home-Cooperaprog-p3 {
    	width: 159px;
    	height: 52px;
    	font-size: 15px;
    	font-weight: 700;
    	line-height: 20px
    }

    .home-Cooperaprog-p3,
    .home-Cooperaprog-p4 {
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1;
    	float: left;
    	margin-left: 15px
    }

    .home-Cooperaprog-p4 {
    	width: 142px;
    	height: 38px;
    	font-size: 28px;
    	font-weight: 400;
    	line-height: 38px
    }

    /* 合作案例标题 */
    .home-Cooperaprog-box1 {
    	width: 100%;
    	min-width: 100%;
    	height: 31.5625rem;
    	position: relative;
    	top: 11px;
    	left: -1px;
    	margin-bottom: 20px
    }

    .home-Cooperaprog-box1-ron {
    	width: 95%;
    	min-width: 98%;
    	height: 31.5625rem;
    	margin: 0 auto
    }

    .home-Cooperaprog-box1-one {
    	width: 32%;
    	height: 30.5625rem;
    	float: left;
    	margin-right: 1.4%;
    	background: #39ab6d;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
    }

    .home-Cooperaprog-box1-one-imtx {
    	width: 100%;
    	height: 13.125rem
    }

    .home-Cooperaprog-box1-one-imtx img {
    	width: 121px;
    	height: 121px;
    	border: 1px solid #707070;
    	border-radius: 50%;
    	opacity: 1;
    	margin: 25px 92px 25px 89px
    }

    .home-Cooperaprog-box1-huining {
    	margin-left: 104px
    }

    .home-Cooperaprog-box1-donghua,
    .home-Cooperaprog-box1-huining {
    	width: 100%;
    	height: 29px;
    	font-size: 20px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 29px;
    	color: #fff;
    	opacity: 1
    }

    .home-Cooperaprog-box1-donghua {
    	margin-left: 108px
    }

    .home-Cooperaprog-box1-menghuang {
    	width: 120px;
    	margin-left: 90px
    }

    .home-Cooperaprog-box1-antuo,
    .home-Cooperaprog-box1-menghuang {
    	height: 29px;
    	font-size: 20px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 29px;
    	color: #fff;
    	opacity: 1
    }

    .home-Cooperaprog-box1-antuo {
    	width: 70%;
    	margin-left: 93px
    }

    .home-Cooperaprog-box1-jingcheng {
    	width: 67%;
    	height: 29px;
    	font-size: 20px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 29px;
    	color: #fff;
    	opacity: 1;
    	margin-left: 112px
    }

    .home-Cooperaprog-box1-one-text {
    	width: 80%;
    	height: 12rem
    }

    .home-Cooperaprog-box1-one-text p {
    	width: 100%;
    	height: 120px;
    	font-size: 16px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 24px;
    	color: #fff;
    	opacity: 1;
    	padding-left: 2rem;
    	padding-top: 1.25rem
    }

    .home-Cooperaprog-box1-two {
    	width: 33%;
    	float: left;
    	margin-right: 5px
    }

    .home-Cooperaprog-box1-three,
    .home-Cooperaprog-box1-two {
    	height: 30.5625rem;
    	background: #4a4949;
    	border: 1px solid #707070;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
    }

    .home-Cooperaprog-box1-three {
    	width: 32%;
    	float: right
    }

    .home-Cooperaprog-box2 {
    	width: 100%;
    	height: 31.5625rem;
    	position: relative;
    	top: -10px;
    	left: -2px
    }

    .home-Cooperaprog-box2-ron {
    	width: 95%;
    	min-width: 98%;
    	height: 31.5625rem;
    	margin: 0 auto
    }

    .home-Cooperaprog-box2-one {
    	width: 32%;
    	margin-right: 1.3%
    }

    .home-Cooperaprog-box2-one,
    .home-Cooperaprog-box2-two {
    	height: 30.5625rem;
    	background: #4a4949;
    	border: 1px solid #707070;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	float: left
    }

    .home-Cooperaprog-box2-two {
    	width: 33%;
    	margin-right: 5px
    }

    .home-Cooperaprog-box2-three {
    	width: 32%;
    	height: 30.5625rem;
    	background: #4a4949;
    	border: 1px solid #707070;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	float: right
    }

    /* 合作案例 end */
    /* 关于我们 start */
    .home-Aboutus-banner {
      width: 100%;
      min-width: 100%;
      height: 43.5625rem;
      background-image: url(../assets/home-image/aboutbackimg.png);
      background-size: 100% 100% !important;
    }

    /* 关于我们标题 */
    .home-Aboutus-banner {
    	width: 100%;
    	min-width: 100%;
    	height: 43.5625rem;
    	background-image: url(/static/img/aboutbackimg.951fd05.png);
    	background-size: 100% 100% !important
    }

    .home-Aboutus-title {
    	width: 5%;
    	height: 9.5rem;
    	z-index: 999;
    	position: relative;
    	top: 56px;
    	left: 100px;
    	display: none
    }

    .home-Aboutus-p1 {
    	width: 20px;
    	height: 148px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	margin-left: 5px
    }

    .home-Aboutus-p1,
    .home-Aboutus-p2 {
    	-webkit-writing-mode: vertical-rl;
    	-ms-writing-mode: tb-rl;
    	writing-mode: vertical-rl;
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1;
    	float: left
    }

    .home-Aboutus-p2 {
    	width: 26px;
    	height: 152px;
    	font-size: 26px;
    	font-weight: 400;
    	line-height: 38px;
    	margin-left: 15px
    }

    .home-Aboutus-title2 {
    	width: 16%;
    	height: 9.5rem;
    	z-index: 999;
    	position: relative;
    	top: 40px;
    	left: 39px;
    	display: block
    }

    .home-Aboutus-p3 {
    	width: 86px;
    	height: 20px;
    	font-size: 16px;
    	font-weight: 700;
    	line-height: 20px
    }

    .home-Aboutus-p3,
    .home-Aboutus-p4 {
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1;
    	float: left;
    	margin-left: 15px
    }

    .home-Aboutus-p4 {
    	width: 137px;
    	height: 44px;
    	font-size: 28px;
    	font-weight: 400;
    	line-height: 38px
    }

    .home-Aboutus-con {
    	width: 80%;
    	min-width: 80%;
    	height: 5.5625rem;
    	position: relative;
    	top: 160px;
    	left: 105px
    }

    .home-Aboutus-con p {
    	width: 100%;
    	height: 89px;
    	font-size: 20px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1
    }

    .home-Aboutus-botton {
    	width: 100%;
    	margin: 18rem 0 7.0625rem;
    	text-align: center
    }

    .home-Aboutus-botton .el-button {
    	border: 1px solid #fff;
    	background-color: transparent;
    	color: #fff
    }

    /* 关于我们 end */
  }

  /* 媒体查询 小于48rem */
  @media screen and (max-width: 48rem) {

    /* 最新活动标题 */
    .home-Latestevents-title2 {
    	width: 38%;
    	height: 4.5rem;
    	position: relative;
    	top: 124px;
    	left: 0;
    	margin-left: 26%;
    	z-index: 999;
    	display: block
    }

    .home-Latestevents-p3 {
    	height: 65px;
    	font-size: 15px;
    	font-weight: 700;
    	line-height: 20px
    }

    .home-Latestevents-p3,
    .home-Latestevents-p4 {
    	width: 100%;
    	font-family: Source Han Sans SC;
    	color: #333;
    	opacity: 1;
    	float: left;
    	margin-left: 15px;
    	text-align: center
    }

    .home-Latestevents-p4 {
    	height: 41px;
    	font-size: 18px;
    	font-weight: 400;
    	line-height: 38px;
    	margin-bottom: 5px
    }

    .home-Latestevents-title {
    	width: 15%;
    	height: 9.5rem;
    	position: relative;
    	top: 70px;
    	left: 50px;
    	z-index: 999;
    	display: none
    }

    .home-Latestevents-p1 {
    	width: 20px;
    	height: 115px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	margin-left: 5px
    }

    .home-Latestevents-p1,
    .home-Latestevents-p2 {
    	font-family: Source Han Sans SC;
    	color: #333;
    	opacity: 1;
    	float: left;
    	display: none
    }

    .home-Latestevents-p2 {
    	width: 26px;
    	height: 152px;
    	font-size: 26px;
    	font-weight: 400;
    	line-height: 38px;
    	margin-left: 15px
    }

    /* one 最新活动 start */
    .home-Latestevents-number-item-2 {
    	width: 100%;
    	min-width: 100%;
    	height: 29rem;
    	margin: 3.125rem auto;
    	position: relative
    }

    .home-Latestevents-item-image-2 {
    	width: 100%;
    	min-width: 100%;
    	height: auto;
    	background-size: 100% 100%;
    	float: left
    }

    .home-Latestevents-item-image-2 img {
    	width: 100%;
    	height: auto
    }

    .home-Latestevents-item-text-b-2 {
    	width: 100%;
    	min-width: 100%;
    	height: 18rem;
    	float: left;
    	background-color: #27cbbd
    }

    .home-Latestevents-item-text-2 {
    	width: 89%;
    	min-width: 88%;
    	height: 18rem;
    	overflow: auto;
    	float: left;
    	margin-left: 2.25rem
    }

    .home-Latestevents-item-text-title-2 {
    	width: 100%;
    	height: 3rem;
    	margin-top: 3.25rem
    }

    .home-Latestevents-item-text-main-2 {
    	width: 98%;
    	min-width: 98%;
    	height: 10rem;
    	margin-top: 1.25rem
    }

    .home-Latestevents-text-2 {
    	width: 85%;
    	min-width: 90%;
    	color: #fff;
    	font-size: 1rem;
    	margin-left: 0
    }

    .home-Latestevents-nubmer-2 {
    	margin-top: 0;
    	float: left
    }

    .home-Latestevents-nubmer-2 span:first-child {
    	font-size: 3rem;
    	font-family: Source Han Sans SC;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	padding-right: .9375rem;
    	text-align: center;
    	margin-left: 0
    }

    .home-Latestevents-nubmer-2 span:nth-child(2) {
    	font-size: 2.5rem;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	margin-top: -.2rem
    }

    .home-Latestevents-small-white-box-2 {
    	right: 96%
    }

    .home-Latestevents-small-green-box-2,
    .home-Latestevents-small-white-box-2 {
    	width: 4.125rem;
    	height: 4.125rem;
    	position: absolute;
    	top: 50%;
    	margin-top: -2.0625rem;
    	background-color: #fff;
    	display: none
    }

    .home-Latestevents-small-green-box-2 {
    	right: 100rem;
    	background-color: #38ab6d
    }

    /* one 最新活动 end */
    /* two 最新活动 start */
    .home-Latestevents-number-item {
    	width: 100%;
    	min-width: 100%;
    	height: 28rem;
    	position: relative;
    	margin: 6.5rem auto 3.125rem
    }

    .home-Latestevents-item-image {
    	width: 100%;
    	min-width: 100%;
    	height: auto;
    	background-size: 100% 100%;
    	float: left
    }

    .home-Latestevents-item-image img {
    	width: 100%;
    	height: auto
    }

    .home-Latestevents-item-text-b {
    	width: 100%;
    	min-width: 100%;
    	height: 17rem;
    	float: left;
    	background: #2d2d2d
    }

    .home-Latestevents-item-text {
    	width: 93%;
    	min-width: 88%;
    	height: 17rem;
    	overflow: auto;
    	float: left
    }

    .home-Latestevents-item-text-title {
    	width: 95%;
    	height: 5rem;
    	margin-top: .25rem
    }

    .home-Latestevents-item-text-main {
    	width: 94%;
    	min-width: 90%;
    	height: 10rem;
    	margin-top: 1.25rem
    }

    .home-Latestevents-text {
    	width: 89%;
    	min-width: 80%;
    	color: #fff;
    	font-size: 1rem;
    	margin-left: 20px
    }

    .home-Latestevents-nubmer {
    	margin-top: 1.875rem;
    	float: left
    }

    .home-Latestevents-nubmer span:first-child {
    	font-size: 3rem;
    	font-family: Source Han Sans SC;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	padding-right: .9375rem;
    	text-align: center;
    	margin-left: 15px
    }

    .home-Latestevents-small-white-box {
    	right: 0;
    	background-color: #fff
    }

    .home-Latestevents-small-green-box,
    .home-Latestevents-small-white-box {
    	width: 4.125rem;
    	height: 4.125rem;
    	position: absolute;
    	top: 50%;
    	margin-top: -2.0625rem;
    	display: none
    }

    .home-Latestevents-small-green-box {
    	right: -4.125rem;
    	background-color: #fff;
    	background: #2d2d2d
    }

    /* two 最新活动 end */
    .product-bntbox {
      width: 100%;
      margin: 4.4375rem 0;
      text-align: center;
    }

    /* 产品与服务 start */
    .home-Productservices-banner {
    	width: 100%;
    	min-width: 100%;
    	height: 42.75rem;
    	background-image: url(../assets/home-image/home-Productservices-banner.jpg);
    	background-size: 100% 100% !important;
    	display: none
    }

    .home-Productservices-title {
    	width: 33%;
    	height: 6.5rem;
    	position: relative;
    	top: 27px;
    	left: 20px;
    	z-index: 999;
    	display: none
    }

    .home-Productservices-p2 {
    	height: 43px;
    	font-size: 30px;
    	font-weight: 400;
    	line-height: 38px;
    	float: left
    }

    .home-Productservices-p1,
    .home-Productservices-p2 {
    	width: 100%;
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1;
    	margin-left: 5px
    }

    .home-Productservices-p1 {
    	height: 67px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	z-index: 99999
    }

    .home-Productservices-title2 {
    	display: block;
    	width: 61%;
    	min-width: 65%;
    	height: 6.5rem;
    	position: relative;
    	top: 1%;
    	left: 0;
    	margin-left: 26%;
    	z-index: 999
    }

    .home-Productservices-p4 {
    	height: 43px;
    	font-size: 19px;
    	font-weight: 400;
    	line-height: 38px;
    	float: left;
    	margin-left: 0
    }

    .home-Productservices-p3,
    .home-Productservices-p4 {
    	width: 74%;
    	font-family: Source Han Sans SC;
    	color: #000;
    	opacity: 1;
    	display: block;
    	text-align: center
    }

    .home-Productservices-p3 {
    	height: 67px;
    	font-size: 13px;
    	font-weight: 700;
    	line-height: 20px;
    	margin-left: 1px;
    	z-index: 99999
    }

    .home-Productservices-box1 {
    	width: 100%;
    	min-width: 100%;
    	height: 275px;
    	background: #fff;
    	position: relative;
    	top: 0;
    	left: 0;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	display: none
    }

    .home-Productservices-box1-ron {
    	width: 95%;
    	height: 275px;
    	margin: 0 auto
    }

    .home-Productservices-box1-ron-con1 {
    	width: 30%;
    	height: 244px;
    	float: left;
    	margin-right: 20px
    }

    .home-Productservices-box1-ron-con2 {
    	width: 30%;
    	height: 244px;
    	float: left;
    	margin-right: 35px
    }

    .home-Productservices-box1-ron-con3 {
    	width: 30%;
    	height: 244px;
    	float: left
    }

    .home-Productservices-box1-ron-con1-imtx {
    	width: 100%;
    	height: 138px
    }

    .home-Productservices-App-img {
    	width: 32px;
    	height: 46px;
    	opacity: 1;
    	padding-top: 37px;
    	padding-left: 123px
    }

    .home-Productservices-wx-img {
    	width: 50px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 35px;
    	padding-left: 114px
    }

    .home-Productservices-wifi-img {
    	width: 68px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 34px;
    	padding-left: 93px
    }

    .home-Productservices-saas-img {
    	width: 60px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 33px;
    	padding-left: 116px
    }

    .home-Productservices-wechat-img {
    	width: 57px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 26px;
    	padding-left: 110px
    }

    .home-Productservices-teach-img {
    	width: 60px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 20px;
    	padding-left: 112px
    }

    .home-Productservices-wechat {
    	padding-left: 41px
    }

    .home-Productservices-App,
    .home-Productservices-wechat {
    	width: 100%;
    	height: 33px;
    	font-size: 22px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	line-height: 18px;
    	color: #39ab6d;
    	opacity: 1;
    	line-height: 50px
    }

    .home-Productservices-App {
    	padding-left: 73px
    }

    .home-Productservices-wifi {
    	padding-left: 13px
    }

    .home-Productservices-saas,
    .home-Productservices-wifi {
    	width: 100%;
    	height: 33px;
    	font-size: 22px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	line-height: 18px;
    	color: #39ab6d;
    	opacity: 1;
    	line-height: 50px
    }

    .home-Productservices-saas {
    	padding-left: 72px
    }

    .home-Productservices-weat {
    	line-height: 18px;
    	line-height: 50px;
    	padding-left: 96px
    }

    .home-Productservices-teach,
    .home-Productservices-weat {
    	width: 100%;
    	height: 33px;
    	font-size: 22px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	color: #39ab6d;
    	opacity: 1
    }

    .home-Productservices-teach {
    	line-height: 18px;
    	line-height: 62px;
    	padding-left: 56px
    }

    .home-Productservices-box1-ron-con1-text {
    	width: 100%;
    	height: 100px
    }

    .home-Productservices-box1-ron-con1-text p {
    	width: 100%;
    	height: auto;
    	font-size: 15px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 24px;
    	color: #333;
    	opacity: 1;
    	text-align: center;
    	padding-left: 0
    }

    .home-Productservices-box2 {
    	width: 100%;
    	height: 275px;
    	background: #fff;
    	position: relative;
    	top: 76px;
    	left: 0;
    	-webkit-box-shadow: 3px 3px 9px rgba(0, 0, 0, .16);
    	box-shadow: 3px 3px 9px rgba(0, 0, 0, .16);
    	display: none
    }

    .home-Productservices-box2-ron {
    	width: 95%;
    	height: 275px;
    	margin: 0 auto
    }

    .product-bntboxtwo {
    	width: 100%;
    	min-width: 100%;
    	margin: 10rem 0 4.0625rem;
    	text-align: center
    }

    /* 48rem 出现一格 */
    .home-Productservices-banner1 {
    	width: 100%;
    	min-width: 100%;
    	height: 85.75rem;
    	display: block
    }

    .home-Productservices-box11-ron {
    	width: 70%;
    	min-width: 88%;
    	height: 222px;
    	display: block;
    	position: relative;
    	margin-left: 6%;
    	background-color: #fff;
    	-webkit-box-shadow: 9px 9px 9px rgba(0, 0, 0, .16);
    	box-shadow: 9px 20px 20px rgba(0, 0, 0, .1);
    	border: .1px solid silver;
    	margin-bottom: 10px
    }

    .home-Productservices-box11-ron-con1 {
    	width: 95%;
    	min-width: 95%;
    	height: 193px;
    	margin: 0 auto
    }

    .home-Productservices-box11-ron-con2 {
    	width: 95%;
    	min-width: 95%;
    	height: 195px;
    	margin: 0 auto
    }

    .home-Productservices-box11-ron-con3 {
    	width: 95%;
    	min-width: 95%;
    	height: 218px;
    	margin: 0 auto
    }

    .home-Productservices-box11-ron-con1-imtx {
    	width: 100%;
    	min-width: 100%;
    	height: 115px
    }

    .home-Productservices-App1-img {
    	width: 32px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 7%;
    	padding-left: 45%
    }

    .home-Productservices-wx1-img {
    	width: 50px;
    	height: 47px;
    	opacity: 1;
    	padding-top: 6%;
    	padding-left: 41%
    }

    .home-Productservices-wifi1-img {
    	width: 52px;
    	height: 35px;
    	opacity: 1;
    	padding-top: 7%;
    	padding-left: 39%
    }

    .home-Productservices-saas1-img {
    	width: 52px;
    	height: 42px;
    	opacity: 1;
    	padding-top: 8%;
    	padding-left: 39%
    }

    .home-Productservices-wechat1-img {
    	width: 52px;
    	height: 41px;
    	opacity: 1;
    	padding-top: 8%;
    	padding-left: 42%
    }

    .home-Productservices-teach1-img {
    	width: 52px;
    	height: 36px;
    	opacity: 1;
    	padding-top: 8%;
    	padding-left: 41%
    }

    .home-Productservices-wechat1 {
    	width: 62%;
    	line-height: 18px;
    	line-height: 43px;
    	padding-left: 19%
    }

    .home-Productservices-App1,
    .home-Productservices-wechat1 {
    	height: 33px;
    	font-size: 16px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	color: #39ab6d;
    	opacity: 1;
    	text-align: center
    }

    .home-Productservices-App1 {
    	width: 45%;
    	min-width: 45%;
    	line-height: 18px;
    	line-height: 50px;
    	padding-left: 28%
    }

    .home-Productservices-wifi1 {
    	width: 73%;
    	padding-left: 15%
    }

    .home-Productservices-saas1,
    .home-Productservices-wifi1 {
    	height: 33px;
    	font-size: 16px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	line-height: 18px;
    	color: #39ab6d;
    	opacity: 1;
    	line-height: 50px;
    	text-align: center
    }

    .home-Productservices-saas1 {
    	width: 42%;
    	padding-left: 29%
    }

    .home-Productservices-weat1 {
    	width: 28%;
    	line-height: 18px;
    	line-height: 41px;
    	padding-left: 37%
    }

    .home-Productservices-teach1,
    .home-Productservices-weat1 {
    	height: 33px;
    	font-size: 16px;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	color: #39ab6d;
    	opacity: 1;
    	text-align: center
    }

    .home-Productservices-teach1 {
    	width: 55%;
    	line-height: 18px;
    	line-height: 45px;
    	padding-left: 23%
    }

    .home-Productservices-box11-ron-con1-text {
    	width: 90%;
    	min-width: 100%;
    	height: 84px
    }

    .home-Productservices-box11-ron-con1-text p {
    	width: 100%;
    	min-width: 90%;
    	font-size: 13px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 24px;
    	color: #333;
    	opacity: 1;
    	text-align: center
    }

    /* 产品与服务 end */
    /* 合作案例 start */
    .home-Cooperaprog-banner {
    	width: 100%;
    	min-width: 100%;
    	height: 63.8125rem;
    	background-image: url(../assets/home-image/Cooperaprogbanner.jpg);
    	background-size: 100% 100% !important;
    	display: none
    }

    .home-Cooperaprog-banner1 {
    	height: 63.8125rem
    }

    /* 合作案例标题 */
    .home-Cooperaprog-title {
    	width: 5%;
    	height: 9.5rem;
    	position: relative;
    	top: 72px;
    	left: 80px;
    	z-index: 999;
    	display: none
    }

    .home-Cooperaprog-p1 {
    	width: 20px;
    	height: 148px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	margin-left: 5px
    }

    .home-Cooperaprog-p1,
    .home-Cooperaprog-p2 {
    	-webkit-writing-mode: vertical-rl;
    	-ms-writing-mode: tb-rl;
    	writing-mode: vertical-rl;
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1;
    	float: left
    }

    .home-Cooperaprog-p2 {
    	width: 26px;
    	height: 152px;
    	font-size: 26px;
    	font-weight: 400;
    	line-height: 38px;
    	margin-left: 15px
    }

    .home-Cooperaprog-title2 {
    	width: 68%;
    	min-width: 69%;
    	height: 6.5rem;
    	position: relative;
    	top: 2%;
    	left: 0;
    	z-index: 999;
    	display: block;
    	margin-left: 27%
    }

    .home-Cooperaprog-p3 {
    	height: 52px;
    	font-size: 13px;
    	font-weight: 700;
    	line-height: 20px
    }

    .home-Cooperaprog-p3,
    .home-Cooperaprog-p4 {
    	width: 65%;
    	font-family: Source Han Sans SC;
    	color: #000;
    	opacity: 1;
    	float: left;
    	margin-left: 0;
    	text-align: center
    }

    .home-Cooperaprog-p4 {
    	height: 38px;
    	font-size: 20px;
    	font-weight: 400;
    	line-height: 38px
    }

    /* 合作案例标题 */
    .home-Cooperaprog-box1 {
      width: 100%;
      min-width: 100%;
      height: 31.5625rem;
      position: relative;
      top: 11px;
      left: -1px;
      margin-bottom: 20px;
    }

    .home-Cooperaprog-box1-ron {
      width: 95%;
      min-width: 98%;
      height: 31.5625rem;
      margin: 0 auto;
    }

    .home-Cooperaprog-box1-one {
      width: 32%;
      height: 30.5625rem;
      float: left;
      margin-right: 1.4%;
      background: #39AB6D;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    }

    .home-Cooperaprog-box1-one-imtx {
      width: 100%;
      height: 13.125rem;
    }

    .home-Cooperaprog-box1-one-imtx img {
      width: 121px;
      height: 121px;
      border: 1px solid #707070;
      border-radius: 50%;
      opacity: 1;
      margin: 25px 92px 25px 60px;
    }

    .home-Cooperaprog-box1-huining {
      width: 100%;
      height: 29px;
      font-size: 20px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 29px;
      color: #FFFFFF;
      opacity: 1;
      margin-left: 75px;
    }

    .home-Cooperaprog-box1-donghua {
      width: 100%;
      height: 29px;
      font-size: 20px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 29px;
      color: #FFFFFF;
      opacity: 1;
      margin-left: 81px;
    }

    .home-Cooperaprog-box1-menghuang {
      width: 120px;
      height: 29px;
      font-size: 20px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 29px;
      color: #FFFFFF;
      opacity: 1;
      margin-left: 63px;
    }

    .home-Cooperaprog-box1-antuo {
      width: 120px;
      height: 29px;
      font-size: 20px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 29px;
      color: #FFFFFF;
      opacity: 1;
      margin-left: 63px;
    }

    .home-Cooperaprog-box1-jingcheng {
      width: 70%;
      height: 29px;
      font-size: 20px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 29px;
      color: #FFFFFF;
      opacity: 1;
      margin-left: 82px;
    }

    .home-Cooperaprog-box1-one-text {
      width: 80%;
      height: 12rem;
    }

    .home-Cooperaprog-box1-one-text p {
      width: 100%;
      height: 120px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 24px;
      color: #FFFFFF;
      opacity: 1;
      padding-left: 2rem;
      padding-top: 1.25rem;
    }

    .home-Cooperaprog-box1-two {
      width: 33%;
      height: 30.5625rem;
      background: #4A4949;
      border: 1px solid #707070;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      float: left;
      margin-right: 5px;
    }

    .home-Cooperaprog-box1-three {
      width: 32%;
      height: 30.5625rem;
      background: #4A4949;
      border: 1px solid #707070;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      float: right;
    }

    .home-Cooperaprog-box2 {
      width: 100%;
      height: 31.5625rem;
      position: relative;
      top: -10px;
      left: -2px;
    }

    .home-Cooperaprog-box2-ron {
      width: 95%;
      min-width: 98%;
      height: 31.5625rem;
      margin: 0 auto;
    }

    .home-Cooperaprog-box2-one {
      width: 32%;
      height: 30.5625rem;
      background: #4A4949;
      border: 1px solid #707070;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      float: left;
      margin-right: 1.3%;
    }

    .home-Cooperaprog-box2-two {
      width: 33%;
      height: 30.5625rem;
      background: #4A4949;
      border: 1px solid #707070;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      float: left;
      margin-right: 5px;

    }

    .home-Cooperaprog-box2-three {
      width: 32%;
      height: 30.5625rem;
      background: #4A4949;
      border: 1px solid #707070;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      float: right;
    }

    /* 48rem 出现 */

    .home-Cooperaprog-banner1 {
    	width: 100%;
    	min-width: 100%;
    	height: 95.8125rem;
    	display: block
    }

    .home-Cooperaprog-box11 {
    	width: 100%;
    	min-width: 100%;
    	height: 31.5625rem;
    	position: relative;
    	top: 11px;
    	left: 0;
    	margin-left: 1%
    }

    .home-Cooperaprog-box11-ron {
    	width: 95%;
    	min-width: 98%;
    	height: 27.5625rem;
    	margin: 0 auto
    }

    .home-Cooperaprog-box11-one {
    	width: 48%;
    	height: 30.5625rem;
    	float: left;
    	margin-right: 1.7%;
    	background: #39ab6d;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
    }

    .home-Cooperaprog-box11-one-imtx {
    	width: 100%;
    	height: 8.125rem
    }

    .home-Cooperaprog-box11-one-imtx img {
    	width: 65px;
    	height: 65px;
    	border: 1px solid #707070;
    	border-radius: 50%;
    	opacity: 1;
    	margin-top: 15%;
    	margin-left: 27%
    }

    .home-Cooperaprog-box11-huining {
    	width: 72%;
    	font-size: 14px
    }

    .home-Cooperaprog-box11-donghua,
    .home-Cooperaprog-box11-huining {
    	height: 29px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 29px;
    	color: #fff;
    	opacity: 1;
    	margin-top: 6%;
    	margin-left: 27%
    }

    .home-Cooperaprog-box11-donghua {
    	width: 60%;
    	font-size: 16px
    }

    .home-Cooperaprog-box11-menghuang {
    	width: 69%;
    	margin-left: 16%
    }

    .home-Cooperaprog-box11-antuo,
    .home-Cooperaprog-box11-menghuang {
    	height: 29px;
    	font-size: 16px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 29px;
    	color: #fff;
    	opacity: 1;
    	margin-top: 6%
    }

    .home-Cooperaprog-box11-antuo {
    	width: 82%;
    	margin-left: 18%
    }

    .home-Cooperaprog-box11-jingcheng {
    	width: 70%;
    	height: 29px;
    	font-size: 16px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 29px;
    	color: #fff;
    	opacity: 1;
    	margin-left: 28%;
    	margin-top: 6%
    }

    .home-Cooperaprog-box11-one-text {
    	width: 80%;
    	height: 12rem
    }

    .home-Cooperaprog-box11-one-text p {
    	width: 100%;
    	height: 197px;
    	font-size: 13px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 24px;
    	color: #fff;
    	opacity: 1;
    	padding-left: 1rem;
    	padding-top: 1.25rem
    }

    .home-Cooperaprog-box11-three,
    .home-Cooperaprog-box11-two {
    	width: 48%;
    	height: 30.5625rem;
    	background: #4a4949;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	float: left
    }

    .home-Cooperaprog-box11-three {
    	margin-right: 1.7%
    }

    .home-Cooperaprog-box22-ron {
    	width: 95%;
    	min-width: 98%;
    	height: 31.5625rem;
    	margin: 0 auto
    }

    .home-Cooperaprog-box22-one,
    .home-Cooperaprog-box22-two {
    	width: 48%;
    	height: 30.5625rem;
    	background: #4a4949;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	float: left
    }

    .home-Cooperaprog-box22-two {
    	margin-right: 1.7%
    }

    .home-Cooperaprog-box22-three {
    	width: 48%;
    	height: 30.5625rem;
    	background: #4a4949;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	float: left
    }

    .home-Cooperaprog-box1-one-bigbotton {
    	width: 100%;
    	height: 2.5rem;
    	margin-top: 6.5625rem
    }

    /* 48rem 出现 */



    /* 合作案例 end */
    /* 关于我们 start */
    .home-Aboutus-banner {
    	width: 100%;
    	min-width: 100%;
    	height: 20.5625rem;
    	background-image: url(/static/img/aboutbackimg.951fd05.png);
    	background-size: 100% 100% !important
    }

    /* 关于我们标题 */
    .home-Aboutus-title {
    	width: 5%;
    	height: 9.5rem;
    	z-index: 999;
    	position: relative;
    	top: 56px;
    	left: 100px;
    	display: none
    }

    .home-Aboutus-p1 {
    	width: 20px;
    	height: 148px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px;
    	margin-left: 5px
    }

    .home-Aboutus-p1,
    .home-Aboutus-p2 {
    	-webkit-writing-mode: vertical-rl;
    	-ms-writing-mode: tb-rl;
    	writing-mode: vertical-rl;
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1;
    	float: left
    }

    .home-Aboutus-p2 {
    	width: 26px;
    	height: 152px;
    	font-size: 26px;
    	font-weight: 400;
    	line-height: 38px;
    	margin-left: 15px
    }

    .home-Aboutus-title2 {
    	width: 40%;
    	height: 4.5rem;
    	z-index: 999;
    	position: relative;
    	top: 0;
    	left: 0;
    	display: block
    }

    .home-Aboutus-p3 {
    	height: 20px;
    	font-size: 14px;
    	font-weight: 700;
    	line-height: 20px
    }

    .home-Aboutus-p3,
    .home-Aboutus-p4 {
    	width: 100%;
    	font-family: Source Han Sans SC;
    	color: #fff;
    	opacity: 1;
    	float: left;
    	margin-left: 15px
    }

    .home-Aboutus-p4 {
    	height: 44px;
    	font-size: 20px;
    	font-weight: 400;
    	line-height: 38px;
    	padding-top: 6%
    }

    .home-Aboutus-con {
    	width: 100%;
    	min-width: 100%;
    	height: 10.5625rem;
    	position: relative;
    	left: 0;
    	top: 0
    }

    .home-Aboutus-con p {
    	width: 95%;
    	height: auto;
    	font-size: 14px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 30px;
    	color: #fff;
    	opacity: 1;
    	margin: 0 auto
    }

    .home-Aboutus-botton {
    	width: 100%;
    	margin: 1rem 0 1.0625rem;
    	text-align: center
    }

    .home-Aboutus-botton .el-button {
    	border: 1px solid #fff;
    	background-color: transparent;
    	color: #fff
    }

    /* 关于我们 end */
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue